import { sellerConstants } from '../../_constants/seller.constants';
import { countryService } from '../../_services/';

export const countryListActions = {
    getCountries
};

function getCountries() {
    return dispatch => {
        dispatch(request());
        countryService.getCountryList()
            .then(
                countries => {
                    dispatch(success(countries));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: sellerConstants.REQUEST_COUNTRIES} }
    function success(countries) { return { type: sellerConstants.RECEIVE_COUNTRIES, countries } }
    function failure(error) { return { type: sellerConstants.COUNTRY_LIST_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/sellers/coutrylist.actions.js